/**
 * Create React App entry point. This and `public/index.html` files can not be
 * changed or moved.
 */
import './dependencies';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import store, { persistor } from './app/store/store';
import App from './App';
import './index.scss';
import 'socicon/css/socicon.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './_metronic/_assets/plugins/line-awesome/css/line-awesome.css';
import './_metronic/_assets/plugins/flaticon/flaticon.css';
import './_metronic/_assets/plugins/flaticon2/flaticon.css';
import './_metronic/_assets/plugins/keenthemes-icons/font/ki.css';
// Style for landing page
import {
    mockAxios,
    setupAxios,
    MetronicLayoutProvider,
    MetronicSplashScreenProvider,
    MetronicSubheaderProvider
} from './_metronic/index';
import { MetronicI18nProvider } from './_metronic/i18n';

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */

/**
 * Creates `axios-mock-adapter` instance for provided `axios` instance, add
 * basic Metronic mocks and returns it.
 *
 * @see https://github.com/ctimmerm/axios-mock-adapter
 */
/* const mock = */ mockAxios(axios);

/**
 * Inject metronic interceptors for axios.
 *
 * @see https://github.com/axios/axios#interceptors
 */
setupAxios(axios, store);

const root = document.querySelector('body');

switch (window.location.hostname) {
    case process?.env?.REACT_APP_THEME_CUOTITAS_HOST:
        root.setAttribute('theme', 'cuotitas');
        break;
    case process?.env?.REACT_APP_THEME_DEMO_HOST:
        root.setAttribute('theme', 'demo');
        break;
    default: root.setAttribute('theme', 'demo'); break;
}

const params = new URL(document.location).searchParams;

if (params.has('theme') && ['cuotitas', 'demo'].includes(params.get('theme'))) {
    root.setAttribute('theme', params.get('theme'));
}

ReactDOM.render(
    <MetronicI18nProvider>
        <MetronicLayoutProvider>
            <MetronicSubheaderProvider>
                <MetronicSplashScreenProvider>
                    <App store={store} persistor={persistor} />
                </MetronicSplashScreenProvider>
            </MetronicSubheaderProvider>
        </MetronicLayoutProvider>
    </MetronicI18nProvider>,
    document.getElementById('root')
);
